/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckAIcon20Solid = forwardRef('CheckAIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M18.516 4.096a1.5 1.5 0 0 1 0 2.12l-8.54 8.541a3.484 3.484 0 0 1-4.928 0l-3.171-3.17a1.5 1.5 0 0 1 2.121-2.122l3.171 3.171c.19.19.496.19.685 0l8.54-8.54a1.5 1.5 0 0 1 2.122 0Z" })));
});
